var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-window',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-window-item',[_c('list',{ref:"tab0",attrs:{"open-tab":_vm.openTab}})],1),_c('v-window-item',[_c('create-or-update',{ref:"tab1",attrs:{"open-tab":_vm.openTab,"item":_vm.item}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }